import { Directive, ElementRef, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
    selector: '[appFormatEmail]'
})
export class FormatEmailDirective {
  private regex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    if (value && this.regex.test(value)) {
      this.el.nativeElement.classList.remove('invalid-email');
      this.el.nativeElement.classList.add('valid-email');
    } else if (value) {
      this.el.nativeElement.classList.remove('valid-email');
      this.el.nativeElement.classList.add('invalid-email');
    } else {
      // Considera cómo manejar el caso cuando el input está vacío
      this.el.nativeElement.classList.remove('valid-email', 'invalid-email');
    }
  }

  validate(control: FormControl): {[key: string]: any} | null {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(control.value);
    return isValid ? null : {'emailInvalid': true};
  }
}